import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import LiveMemberCheckinsLogsStructure from "../../components/live-subscriptions/live-member-checkins/LiveMemberCheckinsLogsStructure";

const LiveMemberCheckins = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Live Member Checkins">
      <LiveMemberCheckinsLogsStructure userInfoData={userInfoData} />;
    </HelmetWrapper>
  );
};

export default LiveMemberCheckins;
